import React, { useState } from "react";
import "../styles/InputField.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const InputField = ({ label, type, value, onChange, placeholder, errorMessage }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = (e) => {
    e.preventDefault(); // Prevents focus from shifting
    e.stopPropagation(); // Stops event bubbling
    setShowPassword(!showPassword);
  };

  return (
    <div className="form-group mb-3" style={{ marginTop: "20px" }}>
      <label>{label}</label>
      <div className="input-with-icon" style={{ position: "relative" }}>
        <input
          type={type === "password" ? (showPassword ? "text" : "password") : type}
          className={`form-control ${errorMessage ? "error-border" : ""}`}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
        {type === "password" && (
          <span 
            className="password-toggle-icon" 
            onMouseDown={togglePasswordVisibility} // Prevents selection
            style={{ cursor: "pointer", position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        )}
      </div>
      {errorMessage && <small className="text-danger">{errorMessage}</small>}
    </div>
  );
};

export default InputField;
